/**
 * Quote List — Lista de Orcamento
 * Gere a lista de produtos para pedido de orcamento (produtos a 0€)
 * Armazena em localStorage e dispara eventos para atualizar UI
 */
(function() {
  'use strict';

  const STORAGE_KEY = 'cinfer_quote_list';

  function getAll() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch(e) {
      return [];
    }
  }

  function save(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('quote-list:updated', { detail: { items: items, count: items.length } }));
  }

  function add(product) {
    const items = getAll();
    const key = product.variantId || product.id;
    const existing = items.find(function(item) { return (item.variantId || item.id) === key; });
    if (existing) {
      existing.quantity = (existing.quantity || 1) + (product.quantity || 1);
    } else {
      items.push({
        id: product.id,
        variantId: product.variantId || null,
        title: product.title,
        variantTitle: product.variantTitle || '',
        sku: product.sku || '',
        url: product.url || '',
        image: product.image || '',
        handle: product.handle || '',
        quantity: product.quantity || 1
      });
    }
    save(items);
    return items;
  }

  function remove(id) {
    var items = getAll().filter(function(item) { return (item.variantId || item.id) !== id; });
    save(items);
    return items;
  }

  function updateQty(id, qty) {
    var items = getAll();
    var item = items.find(function(i) { return (i.variantId || i.id) === id; });
    if (item) {
      item.quantity = Math.max(1, parseInt(qty) || 1);
      save(items);
    }
    return items;
  }

  function clear() {
    save([]);
  }

  function getCount() {
    return getAll().length;
  }

  window.CinferQuoteList = {
    getAll: getAll,
    add: add,
    remove: remove,
    updateQty: updateQty,
    clear: clear,
    getCount: getCount
  };

  // Initialize badge on load
  document.addEventListener('DOMContentLoaded', function() {
    document.dispatchEvent(new CustomEvent('quote-list:updated', {
      detail: { items: getAll(), count: getCount() }
    }));
  });
})();
